import { initializeDB } from '../config/db';
import { EXT_EQUIPMENT_INSPECTION_STORE, EXT_EQUIPMENT_DAILY_CHECK_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const extEquipmentService = {
    // === QR Tag Info ===
    async getInfo(qrToken) {
        const response = await axiosInstance.get(`/ext-equipment/${qrToken}/info`);
        return response.data;
    },

    async getInspections(qrToken) {
        const response = await axiosInstance.get(`/ext-equipment/${qrToken}/inspections`);
        return response.data;
    },

    async getDailyChecks(qrToken) {
        const response = await axiosInstance.get(`/ext-equipment/${qrToken}/daily-checks`);
        return response.data;
    },

    // === Link QR to PO or custom equipment ===
    async linkToPo(qrToken, purchaseOrderId, formType, linkedBy, description, customDescription) {
        const payload = { qrToken, formType, linkedBy };
        if (purchaseOrderId) {
            payload.purchaseOrderId = purchaseOrderId;
            payload.description = description;
        } else if (customDescription) {
            payload.customDescription = customDescription;
        } else if (description) {
            payload.customDescription = description;
        }
        const response = await axiosInstance.post('/ext-equipment/link', payload);
        return response.data;
    },

    // === Relink (admin reset) ===
    async relink(qrToken) {
        const response = await axiosInstance.post('/ext-equipment/relink', { qrToken, confirm: true });
        return response.data;
    },

    // === Update Equipment Contact (assigned employee or custom) ===
    async updateContact(qrToken, payload) {
        const response = await axiosInstance.post(`/ext-equipment/${qrToken}/contact`, payload);
        return response.data;
    },

    // === Inspections (local drafts + submit) ===
    async saveInspectionDraft(inspection) {
        const db = await initializeDB();
        const now = new Date().toISOString();
        const toSave = { ...inspection, updatedAt: now };
        if (!toSave.status) toSave.status = 'draft';
        if (!toSave.createdAt) toSave.createdAt = now;
        await db.put(EXT_EQUIPMENT_INSPECTION_STORE, toSave);
        return toSave;
    },

    async loadInspection(uuid) {
        const db = await initializeDB();
        return await db.get(EXT_EQUIPMENT_INSPECTION_STORE, uuid);
    },

    async deleteInspection(uuid) {
        const db = await initializeDB();
        await db.delete(EXT_EQUIPMENT_INSPECTION_STORE, uuid);
    },

    async submitInspection(inspection) {
        const response = await axiosInstance.post('/ext-equipment/inspection/submit', inspection);
        return response.data;
    },

    // === Daily Checks (local drafts + submit) ===
    async saveDailyCheckDraft(check) {
        const db = await initializeDB();
        const now = new Date().toISOString();
        const toSave = { ...check, updatedAt: now };
        if (!toSave.status) toSave.status = 'draft';
        if (!toSave.createdAt) toSave.createdAt = now;
        await db.put(EXT_EQUIPMENT_DAILY_CHECK_STORE, toSave);
        return toSave;
    },

    async loadDailyCheck(uuid) {
        const db = await initializeDB();
        return await db.get(EXT_EQUIPMENT_DAILY_CHECK_STORE, uuid);
    },

    async deleteDailyCheck(uuid) {
        const db = await initializeDB();
        await db.delete(EXT_EQUIPMENT_DAILY_CHECK_STORE, uuid);
    },

    async submitDailyCheck(check) {
        const response = await axiosInstance.post('/ext-equipment/daily-check/submit', check);
        return response.data;
    },
};

export default extEquipmentService;
